import { LegendProps } from './Legend.type'
import { Box, Typography } from '@mui/material'

export const Legend = ({ legends }: LegendProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        background: (theme) => theme.palette.common.white,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      {legends.map((legend) => {
        return (
          <Box
            key={legend.abbreviation}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              marginRight: '30px',
            }}
          >
            <Box
              sx={{
                background: legend.color,
                width: '10px',
                height: legend.shape === 'square' ? '10px' : '3px',
                mr: 1,
              }}
            />
            <Typography variant="caption">{legend.abbreviation}</Typography>
            <Typography sx={{ margin: '0px 5px' }}>
              {legend.abbreviation && '-'}
            </Typography>
            <Typography variant="body2">{legend.name}</Typography>
          </Box>
        )
      })}
    </Box>
  )
}
